// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"c4effab83d0187662cd1","811":"5cf5d5c7232763558b71"}[chunkId] + ".js";
};